import React, {useState, useEffect} from "react"
import PropTypes from "prop-types"
import {RouteComponentProps} from "react-router"
import {hangPromise} from "@irati/utils/promise"
import categoriesService from "@irati/deals/services/dealCategory"
import history from "@irati/utils/history"
import Loading from "@irati/ui/src/Loading"

interface Props extends RouteComponentProps<{tagIdOrUrl?: string}> {}

const TagLandingPage: React.FC<Props> = (props, context) => {
  const [load, setLoad] = useState(hangPromise())

  useEffect(() => {
    const l = categoriesService.listForCurrentPackage().then((categories) => {
      const {tagIdOrUrl} = props.match.params
      let url = "/categories"
      for (const c of categories) {
        for (const t of c?.tags || []) {
          if (t.url === tagIdOrUrl || t.uuid === tagIdOrUrl) {
            url = `/categories/${c.url}?tags=${t.url}`
            break
          }
        }
      }
      history.push(url, context)
      return hangPromise()
    })

    setLoad(l)
  }, [])

  return <Loading load={load} />
}

TagLandingPage.contextTypes = {
  appPath: PropTypes.string
}

export default TagLandingPage
